function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { RcRangeTimeProvider, RcTimeProvider, useRangeTime } from '../../hooks/date';
import { useLocale } from '@byte-design/config';
import { TimeBase, TimeContent } from '../time-panel';
export function TimeRangePanel(props) {
  var value = props.value,
      format = props.format,
      showHour = props.showHour,
      showMinute = props.showMinute,
      showSecond = props.showSecond,
      hourStep = props.hourStep,
      minuteStep = props.minuteStep,
      secondStep = props.secondStep,
      onChange = props.onChange,
      timeRangDisabled = props.timeRangDisabled,
      extra = _objectWithoutProperties(props, ["value", "format", "showHour", "showMinute", "showSecond", "hourStep", "minuteStep", "secondStep", "onChange", "timeRangDisabled"]);

  var locale = useLocale('date');

  var _useRangeTime = useRangeTime({
    locale: locale,
    value: value,
    format: format,
    showHour: showHour,
    showMinute: showMinute,
    showSecond: showSecond,
    hourStep: hourStep,
    minuteStep: minuteStep,
    secondStep: secondStep,
    onChange: onChange,
    timeRangDisabled: timeRangDisabled
  }),
      root = _useRangeTime.root,
      leftPanel = _useRangeTime.leftPanel,
      rightPanel = _useRangeTime.rightPanel;

  return React.createElement(RcRangeTimeProvider, {
    root: root
  }, React.createElement(TimeBase, Object.assign({
    showHeader: true
  }, extra), React.createElement(RcTimeProvider, {
    root: leftPanel
  }, React.createElement(TimeContent, null)), React.createElement(RcTimeProvider, {
    root: rightPanel
  }, React.createElement(TimeContent, null))));
}